import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_INVESTCORE_USER_SURVEY_QUESTION_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_SURVEY_QUESTION_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_SURVEY_QUESTION_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/user-surveys/questions`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
